import React from 'react';
import Hero from '../components/Hero';
import KurumsalSection from '../components/KurumsalSection';
import ImpactNumber from '../components/ImpactNumber';
import ThePromise from '../components/ThePromise';
import TheSystem from '../components/TheSystem';
import ServicesPreview from '../components/ServicesPreview';
import WhyTarhun from '../components/WhyTarhun';
import ReferencesMarquee from '../components/ReferencesMarquee';
import FeaturedTestimonial from '../components/FeaturedTestimonial';
import InstagramPosts from '../components/InstagramPosts';
import CTASection from '../components/CTASection';

const Home = () => {
  return (
    <>
      <Hero />
      <KurumsalSection />
      <ImpactNumber />
      <ThePromise />
      <TheSystem />
      <ServicesPreview />
      <WhyTarhun />
      <ReferencesMarquee />
      <FeaturedTestimonial />
      <InstagramPosts />
      <CTASection />
    </>
  );
};

export default Home;
